import React, { MouseEventHandler, useCallback, useEffect, useState } from 'react'
import { css } from '@emotion/core'
import uuid from 'react-uuid'

type DropDownItemProps = {
  onClick: MouseEventHandler<HTMLLIElement>
  element: React.ReactElement
  disabled?: boolean
}

type DropDownProps = {
  items: DropDownItemProps[]
  children: any
  direction: 'left' | 'right'
  className?: string
}

export const DropDownMene = (props: DropDownProps) => {
  const [isDropDownOpen, setIsDropDownOpen] = useState<boolean>(false)

  const onClickOtherComponent = useCallback(() => setIsDropDownOpen(false), [])

  useEffect(() => {
    return () => document.removeEventListener('click', onClickOtherComponent)
  }, [])

  useEffect(() => {
    // @see react16用 https://zenn.dev/co9xs/articles/react17-event-delegation
    if (isDropDownOpen) {
      document.addEventListener('click', onClickOtherComponent)
    } else {
      document.removeEventListener('click', onClickOtherComponent)
    }
  }, [isDropDownOpen])

  return (
    <div css={css({ position: 'relative' })} onClick={e => e.stopPropagation()} {...props}>
      <div onClick={() => setIsDropDownOpen(!isDropDownOpen)}>{props.children}</div>
      <div css={dropDownStyle} style={{ display: isDropDownOpen ? 'block' : 'none', [props.direction]: 0 }}>
        <ul>
          {props.items.map(item => (
            <li
              key={uuid()}
              css={dropDownContentStyle}
              onClick={e => !item.disabled && item.onClick(e)}
              className={item.disabled ? '-disabled' : ''}
            >
              {item.element}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

const dropDownStyle = css({
  width: 140,
  zIndex: 50,
  backgroundColor: '#FFF',
  position: 'absolute',
  boxShadow: '0px 3px 10px #0000003d',
  borderRadius: 5,
})

const dropDownContentStyle = css({
  display: 'flex',
  height: 34,
  listStyle: 'none',
  alignItems: 'center',
  padding: '0 16px',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '&:hover': {
    background: '#f2f2f2',
  },
  p: {
    fontSize: 14,
    fontWeight: 'normal',
    color: '#272727',
  },
  '&.-disabled': {
    cursor: 'default',
    '&:hover': { background: 'none' },
    p: { color: 'rgb(204, 204, 204)' },
  },
})
